import angular from 'angular';

angular
    .module('processdelay')

    .factory('ProcessDelayService', [
        '$resource',
        'API_CONFIG',
        function($resource, API_CONFIG) {
            var ProcessDelayService = $resource(
                API_CONFIG.url + '/v1/index-file/:id',
                { id: '@id' },
                {
                    // Recherche suivant les critères
                    search: {
                        url: API_CONFIG.url + '/v1/batch/searchWithProcessDelays',
                        method: 'POST',
                        isArray: true
                    }
                }
            );

            return ProcessDelayService;
        }
    ]);
